export enum Module {
	czMaxPrice = 'czMaxPrice',
	czReimbursement = 'czReimbursement',
	siMaxPrice = 'siMaxPrice',
	hrMaxPrice = 'hrMaxPrice',
	bgMaxPrice = 'bgMaxPrice',
	roMaxPrice = 'roMaxPrice',
	skMaxPrice = 'skMaxPrice',
	ltMaxPrice = 'ltMaxPrice',
}
